import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import type { Permissions } from '@escala/domain/permissions';
import { useStore } from '@/store/AppStore';

import { paths } from './paths';

/**
 * Rota restrita a um perfil. Quem não pode volta para o início — a mesma regra que
 * esconde o item da navegação. A garantia de verdade, com backend, é do servidor.
 */
export default function RequirePermission({
  allow,
  children,
}: {
  allow: (p: Permissions) => boolean;
  children: ReactNode;
}) {
  const { permissions } = useStore();

  return allow(permissions) ? children : <Navigate to={paths.home} replace />;
}
